import { Link } from "react-router-dom";
import PageShell from "./_page-shell";

export default function AboutPage() {
  return (
    <PageShell
      title="À propos"
      subtitle="Aimrane Digital accompagne les entreprises et créateurs qui veulent une présence web professionnelle, claire et efficace."
    >
      <div className="prose prose-invert max-w-3xl prose-p:text-zinc-400 prose-headings:font-display prose-headings:text-white">
        <h2>Freelance web</h2>
        <p>
          Je suis un freelance web oriente resultats : sites rapides, interfaces soignees
          et bases techniques solides. Mon approche combine ecoute de vos objectifs, proposition claire et
          livraison dans des délais réalistes.
        </p>
        <p>
          Du site vitrine au e-commerce, en passant par l'optimisation SEO et les outils sur mesure,
          je reste disponible après la mise en ligne pour faire évoluer votre projet avec vous.
        </p>
        <h3>Liens utiles</h3>
        <p>
          Consultez aussi mes <Link to="/#services">services</Link>, mes <Link to="/#projects">realisations</Link> et la page <Link to="/faqs">FAQ</Link> pour mieux preparer votre projet.
        </p>
        <p className="not-prose mt-8">
          <Link
            to="/#contact"
            className="inline-flex rounded-xl bg-brand px-6 py-3 text-sm font-semibold text-surface shadow-glow transition hover:bg-brand-bright"
          >
            Discuter d’un projet
          </Link>
        </p>
      </div>
    </PageShell>
  );
}
